import React, { Fragment, useEffect, useState } from 'react';
import { BarChart2,Hash, Layout, PieChart, Star, TrendingUp } from 'react-feather';
import { Button, ButtonGroup, Col, Row, UncontrolledTooltip } from 'reactstrap';
import MainFilter from '../components/filters/MainFilter';
import * as echarts from 'echarts/core';
import { GridComponent, TooltipComponent, TitleComponent } from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import { ScatterChart } from 'echarts/charts';
import Spider from '../components/charts/Spider';
import Scatter from '../components/charts/Scatter';
import { summaryRequest } from '../helpers/requests';
import { useDispatch, useSelector } from 'react-redux';
import { dataPoints } from '../helpers/meta';
import Line from '../components/charts/Line';
import SummaryTable from '../components/tables/SummaryTable';
import LeaderBoard from '../components/LeaderBoard';
import Properties from '../components/modals/Properties';
import SummaryCardCompact from '../components/cards/SummaryCardCompact';


echarts.use(
    [TitleComponent, TooltipComponent, GridComponent, ScatterChart, CanvasRenderer]
);

const Home = () => {
    const tag = "HOME";
    const [filter, setFilter] = useState();
    const [tooltip, setTooltip] = useState("");
    const [currentView, setCurrentView] = useState("table");
    const dispatch = useDispatch();
    const summary = useSelector(state => state.summary);
    const features = useSelector(state => state.auth.features);

    const updateFilter = (e) => {
        console.log('eee',e);
        setFilter(e);
        var requestData = {
            params: e,
            dispatch
        }
       
        summaryRequest(requestData);
    }
   
    // const [options, setOptions] = useState(Object.keys(dataPoints).map(key=>{
    //     return {value: key, label: dataPoints[key]}
    // }))
    // const [options, setOptions] = useState( Object.keys(clientFeature?.footfall)?.map(key=>{
    //     return {value: key, label: clientFeature?.footfall[key]}
    // }) )
    const [option, setOption] = useState();

    const [options, setOptions] = useState();
    const [showModal, setShowModal] = useState(false);
    const [footfallFeatures, setFootfallFeatures] = useState([])
    const toggleModal = () => {
        setShowModal(!showModal);
    }
    const summaryMenu = [
        ["table", <Layout size={16} />, "Tabular View"],
        ["radar", <PieChart size={16} />, "Radar Chart"],
        ["scatter", <Hash size={16} />, "Scatter Plot"],
        ["line", <TrendingUp size={16} />, "Line Chart"],
        ["bar", <BarChart2 size={16} />, "Stacked Chart"],
        ["leader", <Star size={16} />, "Leader Board"]
    ];

    useEffect(() => {
            setFootfallFeatures(features.footfall);
            let allOptions = [...features.footfall, ...features.sales]
            setOption(allOptions)
            setOptions(allOptions)
    }, [features])

    console.log('option',option);

    return (
        <Fragment>
            <MainFilter pageTitle="Summary" updateFilter={(e) => updateFilter(e)} type='default'/>
            <h5 className='p-0 mb-3 fw-normal'>Traffic</h5>
            <Row className='mb-4 g-2'>
                {
                    summary && summary.totalCurrent.length > 0 && footfallFeatures &&
                    footfallFeatures.map((item, index) => {
                        let check = isFinite(summary.totalCurrent[0][item.value]);

                        return (
                            <Col md={2} className='' key={"traffic-card-" + index}>
                                <SummaryCardCompact title={item?.label.toUpperCase()} current={check ? summary.totalCurrent[0][item.value] : 0} previous={summary.totalPrevious[0][item.value]} />
                            </Col>
                        )
                    })
                }
                {
                    !footfallFeatures.length &&
                    <span className='className="d-block small opacity-50"'><i>You dont have any feature please contact admin</i></span>
                }
            </Row>{console.log('featuresfeatures',features?.sales)}
            {<h5 className="p-0 mb-3 fw-normal">Sales</h5>}
            <Row className='mb-4 g-2'>
                {
                    summary && summary.totalCurrent.length > 0 && features && features.sales &&
                    features.sales.map((item, index) => {
                        return (
                            <Col md={2} className='' key={"sales-card-" + index}>
                                <SummaryCardCompact title={item.label} current={summary.totalCurrent[0][item.value]} previous={summary.totalPrevious[0][item.value]} />
                            </Col>
                        )
                    })
                }
                {
                    !features?.sales.length>0 &&
                    <span className='className="d-block small opacity-50"'><i>You dont have any feature please contact admin</i></span>
                }
            </Row>
            {/* <Row>
                <Col md={12} className='pb-1' style={{overflowX: "auto", whiteSpace: "nowrap"}}>
                    {
                        summary && summary.totalCurrent.length > 0 &&
                        Object.keys(dataPoints).filter((x, index)=> index>6 ).map((key) => {
                            return <SummaryCard title={dataPoints[key]} current={summary.totalCurrent[0][key]} previous={summary.totalPrevious[0][key]}/>
                        })
                    }
                </Col>
            </Row> */}
            {(footfallFeatures.length || features?.sales) &&
                <Row className='mb-4'>
                    {option && options &&
                        <Col className='text-start'>
                            <Properties option={option} options={options} setOption={(e) => setOption(e)} />
                        </Col>
                    }
                    <Col className='text-end'>
                        <ButtonGroup>
                            {
                                summaryMenu.map((val, index) => {
                                    return (
                                        <Button
                                            href={"#toggle-tab-" + val[0]}
                                            color={currentView == val[0] ? "outline-primary" : "outline-light"}
                                            className='section-tab'
                                            size='sm'
                                            onClick={function noRefCheck() { setCurrentView(val[0]) }}
                                            active={currentView == val[0] ? true : null}
                                            key={"compare-tab-" + index}
                                            id={"toggle-tooltip-" + val[0]}
                                            onMouseOver={() => setTooltip(val[0])}
                                            onMouseOut={() => setTooltip(null)}
                                        >
                                            {val[1]}
                                        </Button>
                                    );
                                })
                            }
                        </ButtonGroup>
                        {
                            summaryMenu.map((val, index) => {
                                return (
                                    <UncontrolledTooltip
                                        flip
                                        isOpen={val[0] == tooltip}
                                        autohide={false}
                                        placement='top'
                                        target={"toggle-tooltip-" + val[0]}
                                        key={"compare-tab-tooltip-" + index}
                                    >
                                        {val[2]}
                                    </UncontrolledTooltip>
                                );
                            })
                        }
                    </Col>
                </Row>
                }
            <div style={{ minHeight: "500px" }}>
                {
                    currentView === "table" && option &&
                    <Row className='mb-4' id={"#toggle-tab-" + currentView}>
                        <Col>
                            <SummaryTable dataOptions={option} />
                        </Col>
                    </Row>
                }
                {
                    currentView === "radar" && option &&
                    <Row className='mb-4' id={"#toggle-tab-" + currentView}>
                        <Col>
                            <Spider dataOptions={option} />
                        </Col>
                    </Row>
                }
                {
                    currentView === "scatter" && option &&
                    <Row className='mb-4' id={"#toggle-tab-" + currentView}>
                        <Col>
                            <Scatter dataOptions={option} />
                        </Col>
                    </Row>
                }
                {
                    currentView === "line" && option &&
                    <Row className='mb-4' id={"#toggle-tab-" + currentView}>
                        <Col>
                            <Line stack={false} dataOptions={option} />
                        </Col>
                    </Row>
                }
                {
                    currentView === "bar" && option &&
                    <Row className='mb-4' id={"#toggle-tab-" + currentView}>
                        <Col>
                            <Line type="bar" stack dataOptions={option} />
                        </Col>
                    </Row>
                }
                {
                    currentView === "leader" && option &&
                    <Row className='mb-4' id={"#toggle-tab-" + currentView}>
                        <Col>
                            <LeaderBoard dataOptions={option} />
                        </Col>
                    </Row>
                }
            </div>
        </Fragment>
    )
}

export default Home;